/**
 * Sample React Native App
 * https://github.com/facebook/react-native
 * @flow
 */

import React, { Component } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform, View, PermissionsAndroid, KeyboardAvoidingView } from "react-native";
import { SafeAreaView as RNSafeAreaView } from "react-native";
import xtend from "xtend";
import par from "par";
import StyledText from "ae-base/Base/StyledText";
import Loader from "ae-base/Base/Loader";

import make_login from "ae-models/factories/login";
import Login from "./Components/Pages/Login";

import make_desktop from "ae-models/factories/desktop";
import Desktop from "./Components/Desktop";

import make_register from "ae-models/factories/register";
import Register from "./Components/Pages/Login/Register";

import make_mobiletokenlogin from "ae-models/factories/mobiletokenlogin";
import Mobiletokenlogin from "./Components/Pages/Login/Mobiletokenlogin";

import make_simplified from "ae-models/factories/mobilesimplified";
import Simplified from "./Components/Simplified";

import make_passwordreset from "ae-models/factories/passwordreset";
import Passwordreset from "./Components/Pages/Login/Passwordreset";

import make_atouchaway from "ae-models/factories/mobileatouchaway";
import Atouchaway from "./Components/aTouchAway/aTouchAway";

import make_powerbutton from "ae-models/factories/powerbutton";
import PowerButton from "./Components/aTouchAway/PowerButton";

import PowerButtonLegacy from "./Components/aTouchAway/Legacy/StandBy";
import RegionSelect from "./Components/Pages/RegionSelect";
import AppComponent from "./AppComponent";
import Localization from "./Localization";
import Config from "./configs/config.json";
import API from "ae-api";
import global from "global";
import * as Sentry from "@sentry/react-native";
import { scrubBreadcrumbs, scrubEvents, getSentryEnvironment } from "./sentry";
import RootErrorBoundary from "./RootErrorBoundary";

import { withSentry } from "./Components/Sentry";

Sentry.init({
	dsn: "https://18328b84c5794409b6b42dcf82a3e666@o951867.ingest.sentry.io/5983304",
	enableNative: Platform.OS !== "web",
	tracesSampleRate: 1.0,
	beforeBreadcrumb: scrubBreadcrumbs,
	beforeSend: scrubEvents,
	environment: getSentryEnvironment(Config.type),
});

var LoginAppComponent = AppComponent(make_login, Login);
var DesktopComponent = AppComponent(make_desktop, Desktop);
var RegisterComponent = AppComponent(make_register, Register);
var MobiletokenloginComponent = AppComponent(make_mobiletokenlogin, Mobiletokenlogin);
var PasswordresetComponent = AppComponent(make_passwordreset, Passwordreset);
var AtouchawayComponent = AppComponent(make_atouchaway, Atouchaway);
var PowerButtonComponent = AppComponent(make_powerbutton, PowerButton);
var PowerButtonLegacyComponent = AppComponent(make_powerbutton, PowerButtonLegacy);
var SimplifiedComponent = AppComponent(make_simplified, Simplified);

class mockingbird extends Component {

	constructor(props) {
		super(props);

		this._current = null;
		this.state = {
			currentView: "loading",
			config: null,
			simpleConfig: null,
		};

		this.handleDesktopLoad = handleDesktopLoad.bind(this);
		this.handleSimplifiedLoad = handleSimplifiedLoad.bind(this);

		this.handleLoginUpdate = handleLoginUpdate.bind(this);
		this.handleLoginLoad = handleLoginLoad.bind(this);

		this.handleRegisterLoad = handleRegisterLoad.bind(this);
		this.handleRegisterUpdate = handleRegisterUpdate.bind(this);

		this.handleMobiletokenloginLoad = handleMobiletokenloginLoad.bind(this);
		this.handleMobiletokenloginUpdate = handleMobiletokenloginUpdate.bind(this);

		this.handlePasswordresetLoad = handlePasswordresetLoad.bind(this);

		this.handleAtouchawayLoad = handleAtouchawayLoad.bind(this);
		this.handleAtouchawayPowerButton = handleAtouchawayPowerButton.bind(this);
		this.handleAtouchawayPowerButtonLegacy = handleAtouchawayPowerButtonLegacy.bind(this);

		this.handleAuthenticated = handleAuthenticated.bind(this);
		this.handleUnauthenticated = handleUnauthenticated.bind(this);
		this.attemptLogin = attemptLogin.bind(this);

		this.handleNoRegion = handleNoRegion.bind(this);
		this.createRegion = createRegion.bind(this);
		this.checkRegion = checkRegion.bind(this);
		this.handleLogout = handle_logout.bind(this);
		this.requestNotificationPermission = requestNotificationPermission.bind(this);
	}

	componentDidMount() {
		global.$app = {};
		this.requestNotificationPermission();
		this.checkRegion();
	}

	render() {
		const { config } = this.state;

		var currentView = this.state.currentView;
		var simpleConfig = this.state.simpleConfig;

		var comp = null;
		if (currentView === "regionselect")
			comp = (
				<RegionSelect config={simpleConfig} createRegion={this.createRegion} />
			);
		if (currentView === "login")
			comp = (
				<LoginAppComponent config={simpleConfig} onUpdated={this.handleLoginUpdate} onLoaded={this.handleLoginLoad} idPrefix={this.props.id_prefix} />
			);
		if (currentView === "desktop")
			comp = (
				<DesktopComponent config={this.state.authedConfig} onLoaded={this.handleDesktopLoad} idPrefix={this.props.id_prefix} />
			);
		if (currentView === "simplified")
			comp = (
				<SimplifiedComponent config={this.state.authedConfig} onLoaded={this.handleSimplifiedLoad} idPrefix={this.props.id_prefix} />
			);
		if (currentView === "register")
			comp = (
				<RegisterComponent config={simpleConfig} onLoaded={this.handleRegisterLoad} onUpdated={this.handleRegisterUpdate} idPrefix={this.props.id_prefix} />
			);
		if (currentView === "mobiletokenlogin")
			comp = (
				<MobiletokenloginComponent config={simpleConfig} onUpdated={this.handleMobiletokenloginUpdate} onLoaded={this.handleMobiletokenloginLoad} idPrefix={this.props.id_prefix} />
			);
		if (currentView === "passwordreset")
			comp = (
				<PasswordresetComponent config={simpleConfig} onLoaded={this.handlePasswordresetLoad} idPrefix={this.props.id_prefix} />
			);
		if (currentView === "atouchaway")
			comp = (
				<AtouchawayComponent config={this.state.authedConfig} onLoaded={this.handleAtouchawayLoad} idPrefix={this.props.id_prefix} />
			);
		if (currentView === "power")
			comp = (
				<PowerButtonComponent config={simpleConfig} onLoaded={this.handleAtouchawayPowerButton} idPrefix={this.props.id_prefix} />
			);
		if (currentView === "power_legacy")
			comp = (
				<PowerButtonLegacyComponent config={simpleConfig} onLoaded={this.handleAtouchawayPowerButtonLegacy} idPrefix={this.props.id_prefix} />
			);
		if (currentView === "loading")
			comp = (
				<Loader />
			);

		if (!comp)
			comp = <StyledText bold>{"Stuck in invalid state: " + currentView}</StyledText>;


		return (
			<AESafeArea>
				<RootErrorBoundary config={config}>
					{comp}
				</RootErrorBoundary>
			</AESafeArea>

		);
	}
}

export default withSentry(mockingbird);

const AESafeArea = (props) => {
	if (Platform.OS === "ios")
		return <RNSafeAreaView style={{ backgroundColor: "black", flexGrow: 1 }}>
			{/* wrapper so that anything that uses absolute positioning would respect safeareaview's padding */}
			<View style={{ position: "relative", flexGrow: 1, backgroundColor: "white" }}>
				{props.children}
			</View>
		</RNSafeAreaView>;
	else if (Platform.OS === "android") {
		const KeyboardProvider = require("react-native-keyboard-controller").KeyboardProvider;
		const SafeAreaViewContext = require("react-native-safe-area-context").SafeAreaView;
		return (
			<KeyboardProvider>
				<SafeAreaViewContext style={{ flex: 1, backgroundColor: "black" }} edges={["top", "bottom"]}>
					<KeyboardAvoidingView style={{ flex: 1 }} behavior={"height"}>
						<View style={{ flex: 1, backgroundColor: "black"}}>
							{props.children}
						</View>
					</KeyboardAvoidingView>
				</SafeAreaViewContext>
			</KeyboardProvider>
		);
	}
	else return props.children;
};

function handleLoginUpdate(model) {
	var currentView = this.state.currentView;
	var config = this.state.config;
	if(currentView === "login" && model.token)
		this.setState({
			currentView: getView(model),
			authedConfig: xtend(config, {
				token: model.token,
				id: model._id || model.id,
				fname: model.fname,
				lname: model.lname,
				organization: model.organization,
				orgGroup: model.orgGroup || model.group,
				user_type: model.type,
			}),
		});
}

function handleDesktopLoad(app) {
	app.dispatcher.on("app:trigger:logout", par(handle_logout.bind(this), app));
	app.dispatcher.on("app:trigger:refresh", handle_refresh.bind(this));
}

function handleLoginLoad(app) {
	app.dispatcher.on("app:trigger:register", par(handle_register.bind(this), app));
	app.dispatcher.on("app:trigger:tokenlogin", par(handle_tokenlogin.bind(this), app));
	app.dispatcher.on("app:trigger:passwordreset", par(handle_passwordreset.bind(this), app));
	if(!Config.host)
		app.dispatcher.on("app:trigger:changeregion", par(handleNoRegion.bind(this), app));
}

function handleRegisterLoad(app) {
	app.dispatcher.on("app:trigger:login", par(handle_logout.bind(this), app));
}

function handleRegisterUpdate(model) {
	if(!model.token) return;
	var config = this.state.config;
	var authData = model.authData;

	this.setState({
		currentView: getView(authData),
		authedConfig: xtend(config, {
			token: model.token,
			id: authData._id,
			fname: authData.fname,
			lname: authData.lname,
			organization: authData.organization,
			orgGroup: authData.orgGroup || authData.group,
			user_type: authData.type,
		}),
	});
}

function handleMobiletokenloginUpdate(model) {
	if(!model.token) return;
	var config = this.state.config;
	AsyncStorage.setItem("token", model.token).then(function(){
		var authData = model.data;
		this.setState({
			currentView: getView(authData),
			authedConfig: xtend(config, {
				token: model.token,
				id: authData._id,
				fname: authData.fname,
				lname: authData.lname,
				organization: authData.organization,
				orgGroup: authData.orgGroup || authData.group,
				user_type: authData.type,
			}),
		});
	}.bind(this));
}

function handle_refresh(){
	this.setState({
		currentView: "loading",
		authedConfig: null,
		config: null,
	}, checkRegion.bind(this));
}

function handleMobiletokenloginLoad(app) {
	app.dispatcher.on("app:trigger:login", par(handle_logout.bind(this), app));
}

function handlePasswordresetLoad(app) {
	app.dispatcher.on("app:trigger:login", par(handle_logout.bind(this), app));
}

function handleAtouchawayLoad(app) {
	app.dispatcher.on("app:trigger:logout", par(handle_logout.bind(this), app));
	app.dispatcher.on("app:trigger:power", par(handle_power_button.bind(this), app));
	app.dispatcher.on("app:trigger:power:legacy", par(handle_power_button_legacy.bind(this), app));
	app.dispatcher.on("app:trigger:refresh", handle_refresh.bind(this));
}

function handleSimplifiedLoad(app){
	app.dispatcher.on("app:trigger:logout", par(handle_logout.bind(this), app));
	app.dispatcher.on("app:trigger:refresh", handle_refresh.bind(this));
}

function handleAtouchawayPowerButton(app) {
	app.dispatcher.on("app:trigger:power", par(handle_power_button_on.bind(this), app));
	app.dispatcher.on("app:trigger:refresh", handle_refresh.bind(this));
}

function handleAtouchawayPowerButtonLegacy(app) {
	app.dispatcher.on("app:trigger:power", par(handle_power_button_on.bind(this), app));
	app.dispatcher.on("app:trigger:refresh", handle_refresh.bind(this));
}

function handle_power_button(app) {
	this.setState({
		currentView: "power",
	});
	app?.models?.usermetrics?._userMetrics?.track("turn off device via power button");
}

function handle_power_button_legacy(app) {
	this.setState({
		currentView: "power_legacy",
	});
	app?.models?.usermetrics?._userMetrics?.track("turn off device via legacy power button");
}

function handle_power_button_on(app) {
	this.setState({
		currentView: "atouchaway",
	});
	app?.models?.usermetrics?._userMetrics?.track("turn on device via power button");
}

async function handle_logout(app) {
	const simpleConfig = this.state.simpleConfig;
	const token = this.state.authedConfig?.token;

	if (token && simpleConfig) {
		var api = new API(simpleConfig);
		api.auth.logout(token);
	}

	await AsyncStorage.multiSet([
		["token", ""],
		["appDisplay", ""],
	]);

	this.setState({
		currentView: "login",
	});

	app?.models?.usermetrics?._userMetrics?.track("navigate to welcome page");
}

function handle_register(app) {
	this.setState({
		currentView: "register",
	});
	app?.models?.usermetrics?._userMetrics?.track("navigate to registration page");
}

function handle_tokenlogin(app) {
	this.setState({
		currentView: "mobiletokenlogin",
	});
	app?.models?.usermetrics?._userMetrics?.track("navigate to token login page");
}

function handle_passwordreset(app) {
	this.setState({
		currentView: "passwordreset",
	});
	app?.models?.usermetrics?._userMetrics?.track("navigate to password reset page");
}

function isATouchAway(authData) {
	return (authData.type || []).indexOf("atouchaway") !== -1;
}

function isSimplified(authData){
	return (authData.type || []).indexOf("simplified") !== -1;
}

function getView(authData) {
	if(isATouchAway(authData)) return "atouchaway";
	else if(isSimplified(authData)) return "simplified";
	else return "desktop";
}

function handleAuthenticated(token, config, authData) {
	config = config || this.state.config;
	this.setState({
		currentView: getView(authData),
		authedConfig: xtend(config, {
			token: token,
			id: authData._id,
			fname: authData.fname,
			lname: authData.lname,
			organization: authData.organization,
			orgGroup: authData.orgGroup || authData.group,
			user_type: authData.type,
		}),
	});
}

function handleUnauthenticated(app){
	this.setState({
		currentView: "login",
	});
	app?.models?.usermetrics?._userMetrics?.track("navigate to login page");
}

function attemptLogin(simpleConfig, config, token) {
	var api = new API(simpleConfig);

	return api.auth
		.auth(token)
		.then(par(this.handleAuthenticated, token, config))
		.catch(this.handleUnauthenticated);
}

function handleNoRegion(app){
	this.setState({
		currentView: "regionselect",
	});
	app?.models?.usermetrics?._userMetrics?.track("navigate to region select page");
}

function createRegion(region, token){
	if(!Config.host && !region) return this.handleNoRegion();

	var localizedConfig = xtend(Config, {
		localization: Localization,
	});

	var hosts = Config.hosts || [];
	var config = hosts.reduce(function(acc, host){
		if(host.name === region)
			acc = xtend(acc, host);

		return acc;
	}, localizedConfig);

	var simpleConfig = xtend(config, {
		simple: true,
	});

	this.setState({
		config: config,
		simpleConfig: xtend(config, {
			simple: true,
		}),
	});

	return this.attemptLogin(simpleConfig, config, token);
}

function checkRegion(){
	var token = this.props.token;
	var region = this.props.region;

	var storeKeys = [];
	if(!token)
		storeKeys.push("token");
	if(!region)
		storeKeys.push("region");

	return AsyncStorage.multiGet(storeKeys, function(err, stores){
		if(err) return console.error(err);
		var values = flatten(stores);
		var storeToken = values.token || token;
		var storeRegion = values.region || region;

		if(storeToken && !storeRegion)
			return this.createRegion("Canada", token);
		else if(!storeToken && !storeRegion)
			return this.createRegion();
		else
			return this.createRegion(storeRegion, storeToken);
	}.bind(this));
}

function flatten(array){
	return array.reduce(function(acc, ele){
		acc[ele[0]] = ele[1];
		return acc;
	}, { });
}

async function requestNotificationPermission() {
	if(Platform.OS === "android" && Platform.Version > 32) {
		let granted = await PermissionsAndroid.check(
			PermissionsAndroid.PERMISSIONS.POST_NOTIFICATIONS
		);
		let status;
		while(!granted && status !== PermissionsAndroid.RESULTS.NEVER_ASK_AGAIN)
			try {
				status = await PermissionsAndroid.request(
					PermissionsAndroid.PERMISSIONS.POST_NOTIFICATIONS
				);
			} catch (err) {
				console.warn("requestNotificationPermission error: ", err);
			}
	}
}
